import tippy from 'tippy.js'

const tooltipOptions = {
    allowHTML: true,
    placement: 'top-end',
    maxWidth: 270,
    offset: ({ placement }) => {
        switch (placement) {
            case 'top-start':
            case 'bottom-start':
                return [-11, 20]
            case 'top-end':
            case 'bottom-end':
                return [11, 20]
            default:
                return [0, 20]
        }
    },
    trigger: 'click focusin mouseenter',
    arrow: false,
    interactive: true,
    onUntrigger(instance, event) {
        event.preventDefault()
    },
    onTrigger(instance, event) {
        event.preventDefault()
    },
}

export const initTooltips = (root = document) => {
    root.querySelectorAll('[data-tippy-content]').forEach(el => {
        if (!el._tippy) {
            tippy(el, tooltipOptions)
        }
    })
}

window.initTooltips = initTooltips